<template>
  <div class="row d-flex align-items-center mt-1">
    <div class="col-9">
      <input
        type="text"
        class="form-control"
        placeholder="Account head"
        v-model="account"
      />
    </div>
    <div class="col-3">
      <button
        class="btn btn-sm btn-success float-end"
        v-if="account"
        @click="addAccount()"
      >
        Add
      </button>
    </div>
  </div>
</template>
<script setup>
import { useStore } from "../../store/index";
import { auth, db } from "../../firebase/config";
import { collection, addDoc } from "firebase/firestore";
import { ref } from "vue";
const account = ref("");
const store = useStore();
const addAccount = async () => {
  const accountObj = {
    user: auth.currentUser.uid,
    org: store.active_org,
    name: account.value,
    active: true,
    journal: {},
  };
  await addDoc(collection(db, "accounts"), accountObj);

  store.setAction("");
};
</script>
